const selectors = {
  block: "[data-downloads]",
  tab: "[data-downloads-tab]",
  panel: "[data-downloads-panel]",
};

const setActiveTab = (activeIndex, panels) =>
  panels.forEach((panel, index) => panel.setAttribute("data-downloads-panel", index === activeIndex ? "active" : ""));

const initBlock = (block) => {
  const tabs = block.querySelectorAll(selectors.tab);
  const panels = block.querySelectorAll(selectors.panel);

  tabs.forEach((tab, index) => tab.addEventListener("click", () => setActiveTab(index, panels)));

  tabs[0].click();
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
